<div class="cd-overlay" *ngIf="state?.open" (click)="cancel()">
  <div class="cd-dialog" role="dialog" [attr.aria-modal]="true" (click)="$event.stopPropagation()">
    <div class="cd-header">
      <span class="cd-icon" [class.cd-icon-danger]="state.danger" [class.cd-icon-info]="!state.danger">
        <svg *ngIf="state.danger" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
        </svg>
        <svg *ngIf="!state.danger" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clip-rule="evenodd"/>
        </svg>
      </span>
      <h3 class="cd-title">{{ state.title }}</h3>
    </div>
    <p class="cd-message">{{ state.message }}</p>
    <div class="cd-actions">
      <button class="cd-btn cd-btn-cancel" (click)="cancel()">Cancel</button>
      <button class="cd-btn" [class.cd-btn-danger]="state.danger" [class.cd-btn-confirm]="!state.danger" (click)="confirm()">
        {{ state.confirmLabel }}
      </button>
    </div>
  </div>
</div>
